import React, { Suspense, lazy, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import Navbar from "./Components/Navbar";
import Middleware from "./Components/Middlewares/Middleware";
import AshokaMiddleware from "./Components/Middlewares/AshokaMiddleware";
import { ThemeProvider } from "./Utils/ThemeContext";
import { requestNotificationPermission, onMessageListener } from "./firebase";
import { MiscApi } from "./Components/Apis";
import GlobalLoader from "./Components/GlobalLoader";

const Home = lazy(() => import("./Components/Home"));
const LoginPage = lazy(() => import("./Components/Login"));
const AshokaLogin = lazy(() => import("./Components/AshokaLogin"));
const Dashboard = lazy(() => import("./Components/Dashboard"));
const AllOrders = lazy(() => import("./Components/AllOrders"));
const Quantity = lazy(() => import("./Components/Quantity"));
const Download = lazy(() => import("./Components/Download"));
const ArjeeVideo = lazy(() => import("./Components/ArjeeVideo/ArjeeVideo"));
const VyaktigatArjeeSlot = lazy(
  () => import("./Components/VyaktigatArjeeSlot"),
);
const Arjee = lazy(() => import("./Components/Arjee/Arjee"));
const ArjeePdf = lazy(() => import("./Components/ArjeePdf"));
const HomeImages = lazy(() => import("./Components/HomeImages"));
const GalleryImages = lazy(() => import("./Components/GalleryImages"));
const UploadVyaktigatArjeeImage = lazy(
  () => import("./Components/UploadVyaktigatArjeeImage"),
);
const BheedDashboard = lazy(() => import("./Components/Bheed/BheedDashboard"));
const AddArjee = lazy(() => import("./Components/AddArjee"));
const SwayamArjee = lazy(() => import("./Components/SwayamArjee"));
const SwayamArjeeSlots = lazy(() => import("./Components/SwayamArjeeSlots"));
const SwayamReferralDashboard = lazy(
  () => import("./Components/SwayamReferral/SwayamReferralDashboard"),
);
// const ViewBheed = lazy(() => import("./Components/Bheed/ViewBheed"));

const HotelDashboard = lazy(() => import("./Components/ParamStays/Dashboard"));
// const LakhiMela = lazy(
// () => import("./Components/LakhiMela"),
// );
const Reviews = lazy(() => import("./Components/Reviews"));
const MapRoutesAdmin = lazy(
  () => import("./Components/MapRoutes/MapRoutesAdmin"),
);
const MapRouteLogs = lazy(() => import("./Components/MapRoutes/MapRouteLogs"));
const NotificationAdmin = lazy(
  () => import("./Components/Notifications/NotificationAdmin"),
);
const CallbackRequest = lazy(
  () => import("./Components/CallbackRequest/CallbackRequest"),
);
const AddBlog = lazy(() => import("./Components/Blog/AddBlog"));
const BlogDashboard = lazy(() => import("./Components/Blog/BlogDashboard"));
const CsvUploads = lazy(() => import("./Components/CsvUpload/CsvUploads"));
const CsvUploadDetails = lazy(
  () => import("./Components/CsvUpload/CsvUploadDetails"),
);
const BhogArjeeList = lazy(
  () => import("./Components/BhogArjee/BhogArjeeList"),
);
const CsvExporter = lazy(() => import("./Components/CsvExporter"));
const ChatbotDashboard = lazy(
  () => import("./Components/Chatbot/ChatbotDashboard"),
);
const WhatsAppDashboard = lazy(
  () => import("./Components/WhatsApp/WhatsAppDashboard"),
);
const WhatsAppLogs = lazy(() => import("./Components/WhatsApp/WhatsAppLogs"));
const CouponDashboard = lazy(
  () => import("./Components/Coupon/CouponDashboard"),
);
const BroadcastDashboard = lazy(
  () => import("./Components/WhatsApp/BroadcastDashboard"),
);
const FeedbackDashboard = lazy(
  () => import("./Components/Feedback/FeedbackDashboard"),
);
const ErrorLogs = lazy(() => import("./Components/ErrorLogs"));
const ArjeeTrackingDashboard = lazy(
  () => import("./Components/Tracking/ArjeeTrackingDashboard"),
);
const LapsedArjees = lazy(
  () => import("./Components/LapsedArjees/LapsedArjees"),
);

const routesConfig = [
  { path: "/", element: Home, middleware: Middleware },
  { path: "/login", element: LoginPage },
  { path: "/ashoka-login", element: AshokaLogin },
  { path: "/arjee-pdf", element: ArjeePdf, middleware: Middleware },
  { path: "/home-images", element: HomeImages, middleware: Middleware },
  { path: "/gallery-images", element: GalleryImages, middleware: Middleware },
  { path: "/dashboard", element: Dashboard, middleware: AshokaMiddleware },
  { path: "/orders", element: AllOrders, middleware: Middleware },
  { path: "/arjee", element: Arjee, middleware: Middleware },
  { path: "/add-arjee", element: AddArjee, middleware: Middleware },
  { path: "/download", element: Download, middleware: Middleware },
  { path: "/arjee-video", element: ArjeeVideo, middleware: Middleware },
  {
    path: "/upload-image",
    element: UploadVyaktigatArjeeImage,
    middleware: Middleware,
  },
  { path: "/bheed-bhad", element: BheedDashboard, middleware: Middleware },
  // { path: "/lakhi-mela", element: LakhiMela, middleware: Middleware },
  { path: "/quantity", element: Quantity, middleware: Middleware },
  { path: "/swayam-arjee", element: SwayamArjee, middleware: Middleware },
  {
    path: "/swayam-arjee-slots",
    element: SwayamArjeeSlots,
    middleware: Middleware,
  },
  {
    path: "/swayam-referrals",
    element: SwayamReferralDashboard,
    middleware: Middleware,
  },
  // { path: "/view-bheed", element: ViewBheed, middleware: Middleware },
  {
    path: "/vyaktigat-arjee-slots",
    element: VyaktigatArjeeSlot,
    middleware: Middleware,
  },
  { path: "/reviews", element: Reviews, middleware: Middleware },
  {
    path: "/param-stays",
    element: HotelDashboard,
    middleware: AshokaMiddleware,
  },
  { path: "/map-routes", element: MapRoutesAdmin, middleware: Middleware },
  { path: "/map-route-logs", element: MapRouteLogs, middleware: Middleware },
  {
    path: "/notifications",
    element: NotificationAdmin,
    middleware: Middleware,
  },
  {
    path: "/callback-requests",
    element: CallbackRequest,
    middleware: Middleware,
  },
  {
    path: "/add-blog",
    element: AddBlog,
    middleware: Middleware,
  },
  {
    path: "/blogs",
    element: BlogDashboard,
    middleware: Middleware,
  },
  {
    path: "/csv-uploads",
    element: CsvUploads,
    middleware: Middleware,
  },
  {
    path: "/csv-uploads/:id",
    element: CsvUploadDetails,
    middleware: Middleware,
  },
  {
    path: "/bhog-arjee",
    element: BhogArjeeList,
    middleware: Middleware,
  },
  {
    path: "/csv-exporter",
    element: CsvExporter,
    middleware: Middleware,
  },
  {
    path: "/chatbot",
    element: ChatbotDashboard,
    middleware: Middleware,
  },
  {
    path: "/whatsapp",
    element: WhatsAppDashboard,
    middleware: Middleware,
  },
  {
    path: "/whatsapp/logs",
    element: WhatsAppLogs,
    middleware: Middleware,
  },
  {
    path: "/coupons",
    element: CouponDashboard,
    middleware: Middleware,
  },
  {
    path: "/wa-broadcasts",
    element: BroadcastDashboard,
    middleware: Middleware,
  },
  {
    path: "/feedbacks",
    element: FeedbackDashboard,
    middleware: Middleware,
  },
  {
    path: "/error-logs",
    element: ErrorLogs,
    middleware: Middleware,
  },
  {
    path: "/arjee-tracking",
    element: ArjeeTrackingDashboard,
    middleware: Middleware,
  },
  {
    path: "/lapsed-arjees",
    element: LapsedArjees,
    middleware: Middleware,
  },
];

/**
 * Handles FCM token registration and foreground notification display.
 * Shows a small banner prompting the admin to enable notifications.
 */
const FIFTEEN_DAYS_MS = 15 * 24 * 60 * 60 * 1000;
const NOTIF_PROMPT_KEY = "pb_admin_notif_prompt_at";

const AdminNotificationInit = () => {
  const token = useSelector((state) => state.user.token);
  const [showBanner, setShowBanner] = React.useState(false);

  useEffect(() => {
    if (!token) return;

    const perm =
      "Notification" in window ? Notification.permission : "unsupported";
    console.log("🔔 Admin FCM Init — token exists, permission:", perm);

    // If permission is already granted, silently register the token
    if (perm === "granted") {
      registerFCMToken(token);
      setShowBanner(false);
    } else if (perm === "default" || perm === "denied") {
      // Show prompt banner only once every 15 days if not enabled
      const lastPrompt = localStorage.getItem(NOTIF_PROMPT_KEY);
      const isCooldownActive =
        lastPrompt && Date.now() - Number(lastPrompt) < FIFTEEN_DAYS_MS;

      if (!isCooldownActive) {
        setShowBanner(true);
      } else {
        setShowBanner(false);
      }
    }

    // Listen for foreground messages regardless
    const unsubscribe = onMessageListener((payload) => {
      const { title, body } = payload.notification || {};
      if (title && Notification.permission === "granted") {
        new Notification(title, { body, icon: "/logo.png" });
      }
    });

    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem(NOTIF_PROMPT_KEY, Date.now().toString());
  };

  const handleEnableNotifications = async () => {
    setShowBanner(false);
    try {
      const fcmToken = await requestNotificationPermission();
      if (fcmToken && token) {
        await axios.post(
          MiscApi.RegisterFCMToken,
          { fcmToken },
          { headers: { Authorization: `Bearer ${token}` } },
        );
      } else {
        localStorage.setItem(NOTIF_PROMPT_KEY, Date.now().toString());
      }
    } catch (err) {
      localStorage.setItem(NOTIF_PROMPT_KEY, Date.now().toString());
    }
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[4000] max-w-sm bg-surface-raised border border-s-border rounded-2xl shadow-2xl p-4 flex items-start gap-3 animate-[slideUp_0.3s_ease-out]">
      <div className="text-2xl mt-0.5">🔔</div>
      <div className="flex-1 pr-4 relative">
        <button
          onClick={handleDismiss}
          className="absolute -top-1 -right-2 text-gray-400 hover:text-gray-600 dark:hover:text-white text-sm p-1 transition-colors"
          title="Dismiss for 15 days"
        >
          ✕
        </button>
        <p className="text-sm font-semibold text-on-surface">
          Enable Notifications
        </p>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          Get alerts for new Swayam Arjee bookings & WhatsApp handoffs.
        </p>
        <div className="flex gap-2 mt-2.5">
          <button
            onClick={handleEnableNotifications}
            className="px-3 py-1.5 text-xs font-semibold bg-gradient-to-r from-orange-500 to-rose-500 text-white rounded-lg shadow hover:shadow-orange-500/30 transition-all hover:-translate-y-0.5"
          >
            Allow
          </button>
          <button
            onClick={handleDismiss}
            className="px-3 py-1.5 text-xs font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-white transition-colors"
          >
            Later (15 days)
          </button>
        </div>
      </div>
    </div>
  );
};

const registerFCMToken = async (authToken) => {
  try {
    const fcmToken = await requestNotificationPermission();
    if (!fcmToken) return;
    await axios.post(
      MiscApi.RegisterFCMToken,
      { fcmToken },
      { headers: { Authorization: `Bearer ${authToken}` } },
    );
  } catch (err) {
    // silently fail
  }
};

const App = () => {
  return (
    <ThemeProvider>
      <AdminNotificationInit />
      <div className="bg-surface text-on-surface min-h-screen transition-colors duration-200">
        <Navbar />
        <Suspense fallback={<GlobalLoader />}>
          <Routes>
            {routesConfig.map(
              ({ path, element: Element, middleware: MiddlewareWrapper }) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    MiddlewareWrapper ? (
                      <MiddlewareWrapper>
                        <Element />
                      </MiddlewareWrapper>
                    ) : (
                      <Element />
                    )
                  }
                />
              ),
            )}

            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Suspense>
      </div>
    </ThemeProvider>
  );
};

export default App;
